import React from "react"
import { RefreshCw, Search } from "lucide-react"
import Button from "../common/Button.jsx"

export default function CustomersFilters({
    searchTerm,
    onSearchTermChange,
    onSearchSubmit,
    onRefresh,
    onNotImplemented = () => {},
    showStatusDropdown = true,
    showTypesDropdown = true,
    sortValue = "name-asc",
    onSortChange = () => {},
}) {
    return (
        <div className="mb-4 d-flex flex-column flex-lg-row gap-3 min-w-0">
            <form className="flex-grow-1 position-relative min-w-0" style={{ minWidth: 0 }} onSubmit={onSearchSubmit}>
                <Search
                    className="position-absolute text-secondary"
                    style={{
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                    }}
                    size={20}
                />
                <input
                    type="text"
                    placeholder="Search customers..."
                    className="form-control ps-5"
                    style={{ paddingLeft: "2.5rem" }}
                    value={searchTerm}
                    onChange={(e) => onSearchTermChange(e.target.value)}
                />
            </form>
            <div className="d-flex flex-wrap gap-2">
                <Button variant="outline" size="sm" onClick={onRefresh}>
                    <span className="me-2"><RefreshCw size={16} /></span>
                    Refresh
                </Button>
                {showStatusDropdown ? (
                    <select
                        className="form-select form-select-sm v2-not-implemented-btn"
                        style={{ width: "auto", fontSize: "0.875rem" }}
                        defaultValue="all"
                        title="Not implemented yet"
                        onChange={(e) => {
                            e.currentTarget.value = "all"
                            onNotImplemented?.()
                        }}
                    >
                        <option value="all">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>
                ) : null}
                {showTypesDropdown ? (
                    <select
                        className="form-select form-select-sm v2-not-implemented-btn"
                        style={{ width: "auto", fontSize: "0.875rem" }}
                        defaultValue="all"
                        title="Not implemented yet"
                        onChange={(e) => {
                            e.currentTarget.value = "all"
                            onNotImplemented?.()
                        }}
                    >
                        <option value="all">All Types</option>
                        <option value="sport">Sport</option>
                        <option value="retail">Retail</option>
                        <option value="wholesale">Wholesale</option>
                        <option value="co-pack">Co-pack</option>
                    </select>
                ) : null}
                <select
                    className="form-select form-select-sm"
                    style={{ width: "auto", fontSize: "0.875rem" }}
                    value={sortValue}
                    onChange={(e) => {
                        onSortChange(e.currentTarget.value)
                    }}
                >
                    <option value="name-asc">Name A-Z</option>
                    <option value="name-desc">Name Z-A</option>
                    <option value="created-desc">Newest First</option>
                    <option value="created-asc">Oldest First</option>
                </select>
            </div>
        </div>
    )
}
